import { render, staticRenderFns } from "./H5Article.vue?vue&type=template&id=561f20f0&scoped=true&"
import script from "./H5Article.vue?vue&type=script&lang=js&"
export * from "./H5Article.vue?vue&type=script&lang=js&"
import style0 from "./H5Article.vue?vue&type=style&index=0&id=561f20f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561f20f0",
  null
  
)

export default component.exports